import React from "react";
import { Grid, Typography } from "@mui/material";
import DetailRow from "../../pages/common-features/DetailRow";

interface ProvideLoanDetailsTabProps {
  partnerDetails: any[];
  isMobile: boolean;
}

const ProvideLoanDetailsTab: React.FC<ProvideLoanDetailsTabProps> = ({
  partnerDetails,
  isMobile,
}) => {
  if (!partnerDetails || partnerDetails.length === 0)
    return (
      <Grid item xs={12}>
        <Typography variant="body2" color="textSecondary">
          No details available.
        </Typography>
      </Grid>
    );
  const capitalizeValue = (val: any) => {
    if (val === null || val === undefined) return "";

    return String(val)
      .replace(/_/g, " ")
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  return (
    <>
      {partnerDetails?.map((field: any, subIndex: number) => {
        const skipNames = [
          "applicationid",
          "salesmanagername",
          "salesmanageremail",
          "salesmanagermobile",
          "status",
          "country",
          "university",
          "institute",
          "coursename",
          "coursecategory",
          "admissionstatus",
          "coursetype",
          "createdon",
          "product",
        ];
        if (skipNames.includes((field.name || "").toLowerCase())) return null;

        // Replace Applied Loan Amount label with Loan Amount
        let displayLabel = field.label;
        let displayValue = capitalizeValue(field.value);

        if (
          (field.name || "").toLowerCase() === `appliedloanamount`.toLowerCase()
        ) {
          displayLabel = "Loan Amount";
          displayValue = `₹ ${capitalizeValue(field.value)}`;
        }

        console.log(displayValue, "displayValue");

        return (
          <Grid item xs={12} sm={6} md={3} key={subIndex}>
            <DetailRow
              item={{
                label: displayLabel,
                value: displayValue,
                isVerified: false,
              }}
            />
          </Grid>
        );
      })}
    </>
  );
};

export default ProvideLoanDetailsTab;
